// extracted by mini-css-extract-plugin
module.exports = {"Content":"Content_Content__3xZY3","ContentCenter":"Content_ContentCenter__12tOC"};